<template>
    <div class="form-line">
    <slot></slot>
            <input type="text" name="verifycode" class="gwi-ipt ipt-code" v-model="code" placeholder="验证码" maxlength="6">
        <button type="button" id="btn-verifycode" class="btn-code" :disabled="disabled" @click="sendVerifyCode">{{btnText}}</button>
    </div>
</template>
<script>
    import utils from 'utils'
    export default {
        props: {
            value: String,
            url: {
                type: String,
                required: true,
            },
            namespace:String,
            param: Object,
        },
        data: function() {
            return {
                code: this.model,
                btnText: '获取验证码',
                setdisabled: '',
                waitTime:60
            }
        },
        created(){
            this.$store.commit('initCountdown', this.namespace);
        },
        computed:{
            disabled(){
                this.setdisabled =this.$store.state.stateModule.count[this.namespace];
                return this.$store.state.stateModule.count[this.namespace] !== this.waitTime
            },
        },
        methods: {
            sendVerifyCode: function($event) {
                if (utils.verifyNo().verifyCodeNo(this.param)) {
                    $event.target.disabled = true;
                    this.btnText = '60秒';
                    this.$http.post(this.url, this.param).then(response => {
                        if (response.body.resultCode === this.constant.RESULT_SUCCESS) {
                            this.$store.commit('countdown', this.namespace)
                        } else {
                            $event.target.disabled = false;
                            this.btnText = '获取验证码';
                            utils.alert(response.data.resultMsg);
                        }
                    },()=>{
                        $event.target.disabled = false;
                        this.btnText = '获取验证码';
                    });
                    // 验证码已发送
                    this.$emit('send-finish')
                }
            },
            codeChange: function($event) {
                this.$emit('codechange', $event.target.value)
            }
        },
        watch: {
            code(val) {
                this.$emit('input', val)
            },
            value(val) {
                this.code = val;
            },
            setdisabled(val){
                if(val !== this.waitTime){
                    this.btnText = this.$store.state.stateModule.count[this.namespace] + '秒';
                    return
                }
                this.btnText = '获取验证码'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// VerifyCode.vue?5568d7b7